import { Cart } from "../cart/cart";

const cart = new Cart();

/**
 * Add items to cart
 * @param  {jQ Obj} $this The element, which fired the event
 * @return {Void}
 */
export const addItems = ($this) => {
  const items = [];
  let $form = $this.closest("form");

  if ($this.hasClass("js-sticky-cta-btn")) {
    $form = $(".product-form");
  }

  let variantClass = $this
    .prop("class")
    .split(" ")
    .find((_class) => _class.includes("js-variant-quantity"));

  variantClass = variantClass ? variantClass.split("-") : variantClass;

  const variantId = variantClass[variantClass.length - 1];

  const id = variantId || $form.find('[name="id"]').val();
  const quantity = $form.find('[name="quantity"]').val();
  const $optionsAdditional = $(".selected-option-additional");

  if ($optionsAdditional.length) {
    let propertiesObj = { "Additional options": "" };

    for (let index = 0; index < $optionsAdditional.length; index++) {
      const optionAdditional = $optionsAdditional[index];
      let separator = ",";

      if (index === $optionsAdditional.length - 1) {
        separator = "";
      }

      propertiesObj["Additional options"] += optionAdditional.value + separator;
    }

    items.push({ id, quantity, properties: propertiesObj });
  } else {
    items.push({ id, quantity });
  }

  cart.add(items);
};

$(document).on("click", ".js-ajax-add", function (event) {
  event.preventDefault();

  if (!$(this).hasClass("js-notify-me")) {
    $(this).addClass("btn--loading");

    addItems($(this));
  }
});

$(document).on("click", ".js-cross-sell-add", function (event) {
  event.preventDefault();

  const $this = $(this);
  const items = [];
  const id = $this.attr("href").split("id=")[1].split("&quantity")[0];
  const quantity = $this.attr("href").split("&quantity=")[1];

  items.push({ id, quantity });
  cart.add(items);
});

// Remove
$(document).on("click", ".js-remove", function (event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this.data("variant-id");
  const $product = $this.closest(".js-table-product");

  $product.slideUp();
  cart.updateItem(0, id);
});

// Change
$(document).on("change", ".js-quantity", function (event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this.attr("data-variant-id");
  const quantity = $this.val();
  const $holder = $this.closest(".js-cart-items-holder");

  if ($(".template-cart").length == 0) {
    $holder.addClass("is-busy");
    cart.updateItem(quantity, id);
  }
});
